import { render, staticRenderFns } from "./EditRadio.vue?vue&type=template&id=4d179a6b&scoped=true&"
import script from "./EditRadio.vue?vue&type=script&lang=js&"
export * from "./EditRadio.vue?vue&type=script&lang=js&"
import style0 from "./EditRadio.vue?vue&type=style&index=0&id=4d179a6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d179a6b",
  null
  
)

export default component.exports